/**
 * @generated SignedSource<<33e7269fb844b28c02f6085ad5c365f0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IllustrationCard$data = {
  readonly imageDirectoryUrl: string | null;
  readonly name: string;
  readonly " $fragmentType": "IllustrationCard";
};
export type IllustrationCard$key = {
  readonly " $data"?: IllustrationCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"IllustrationCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IllustrationCard",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "imageDirectoryUrl"
    }
  ],
  "type": "PeopleFieldAggregate"
};

(node as any).hash = "1b10ea5a2187de3f47fb50ebdce5aa03";

export default node;
